/** declare only http service related requests */

import { HttpTokens, QueryAttendeeSearch, GetAttendeeSearchList } from '@/src/types';
import { AxiosService } from '@/utils/axios';
import { AxiosResponse } from 'axios';
import { paramsQueryString } from '@/utils/index';
import { DEFAULT_HTTP_TIMEOUT } from '../..';
/**
 * @description Get attendee list from search query
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const AttendeeSearchGet = (
  prefix: string = 'training/attendees/search',
  trainingId: string,
  params: QueryAttendeeSearch,
  tokens: HttpTokens,
  hardRejection = true
): Promise<GetAttendeeSearchList> => {
  const instance = new AxiosService({ method: 'get', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  const queryUri = paramsQueryString(`${prefix}/${trainingId}`, params);
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };

  return instance.client
    .get(queryUri, config)
    .then((d: AxiosResponse<GetAttendeeSearchList>) => {
      return d.data;
    })
    .catch(instance.defaultHandleError) as Promise<GetAttendeeSearchList>;
};
